
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 102.89 117.03"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M51.45 117a51.44 51.44 0 1151.44-51.45A51.51 51.51 0 0151.45 117zm0-93.58a42.14 42.14 0 1042.13 42.13 42.19 42.19 0 00-42.13-42.1z","fill":"#fbb03b"}}),_c('path',{attrs:{"d":"M51.44 30.06a35.53 35.53 0 1035.53 35.53H51.44zM45.49 8.63H57.4v10.29H45.49zM36.98 0h28.94v8.23H36.98z","fill":"#fbb03b"}})])
          )
        }
      }
    